import React from 'react';
import OrderShipmentTracking from '../../components/admin/OrderShipmentTracking';
import {
  MOCK_SHIPMENT_ORDER_IN_TRANSIT,
  MOCK_SHIPMENT_ORDER_NOT_SHIPPED,
} from '../../helper/shipment_tracking_helper';

/**
 * Static preview for QA screenshots (enabled via REACT_APP_ENABLE_SHIPMENT_PREVIEW=true).
 */
export default function ShipmentTrackingPreview() {
  return (
    <div className="main main-app p-3 p-lg-4" style={{ maxWidth: 960, margin: '0 auto' }}>
      <h4 className="mb-3">Shipment tracking preview</h4>
      <OrderShipmentTracking order={MOCK_SHIPMENT_ORDER_IN_TRANSIT} />
      <OrderShipmentTracking order={MOCK_SHIPMENT_ORDER_NOT_SHIPPED} />
    </div>
  );
}
